import { LinkButton } from "@/molecules/LinkButton"

import styles from "./IntegrationStatusButtonsContainer.module.scss"

import type { LinkOverviewProps } from "."

export const LinkOverview = (props: LinkOverviewProps) => (
  <LinkButton to="/">
    <span className={styles.buttonText}>{props.t("linkToOverview")}</span>
  </LinkButton>
)
